import React from 'react'
import TradingViewWidget from './TradingViewWidget'
import Trad from './Trad'

import '../styles/tradingview.css'
import Trader from './Trader'

const LiveTrading = () => {
  return (
    <>
      <div className="liveTrading">
        <Trader />
        <TradingViewWidget />
        <Trad />
      </div>
    </>
  )
}

export default LiveTrading